import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import Tree from './Tree';

function createItems(start = 0, size = 25) {
  const items = [];

  for (let j = start; j < start + size; j++) {
    const subItem = {
      id: `id-${j}`,
      title: `Folder ${j + 1}`,
      description: `Folder with ${size} items`,
      children: [],
    };

    for (let k = 0; k < size; k++) {
      subItem.children.push({
        id: `id-${j + j}`,
        title: `Folder ${j + 1}.${k + 1}`,
        description: 'Empty folder'
      });
    }
    items.push(subItem);
  }
  return items;
}

class TreeExample extends Component {

  state = {
    columns: ['title', 'description'],
    items: [{
      id: 'root',
      title: 'Root',
      description: 'Root folder',
      children: createItems(),
    }],
    selection: {},
    showHeader: true,
  };

  onChange = e => this.setState(e.target.value);

  onClick = (e, column, cell) => {
    const item = e.target.value;

    window.showAppInfo(`${item.title} (column: ${column} / cell: ${cell})`);
  };

  onCreateMenuItems = item => [
    <Button key="home" iconName="home">{`Home of ${item.title}`}</Button>,
    <Button key="accounts" iconName="accounts">Accounts</Button>,
    <Button key="images" iconName="images">Images</Button>,
  ];

  onExpandCollapse = (e, key, state, expanded) => {
    this.setState({ expanded });
    window.showAppInfo(`${state ? 'Expanded' : 'Collapsed'} ${e.target.value.title}`);
  };

  onSelectionChanged = e => this.setState({ selection: e.target.value });

  hasMore = () => this.state.expanded &&
   Object.keys(this.state.expanded).some(key => this.state.expanded[key]);

  loadMore = () => {
    const root = this.state.items[0];

    this.setState({
      items: [{
        ...root,
        children: root.children.slice().concat(createItems(root.children.length)),
      }],
    });
  };

  pageStart = () => this.state.items[0].children.length;

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Tree.defaultProps} propTypes={Tree.propTypes} propValues={this.state}/>
        <div className="tree-container">
          <Tree {...this.state} onClick={this.onClick} onExpandCollapse={this.onExpandCollapse}
            onSelectionChanged={this.onSelectionChanged} onCreateMenuItems={this.onCreateMenuItems}
            hasMore={this.hasMore} loadMore={this.loadMore} pageStart={this.pageStart}/>
        </div>
        <SourceCode querySelector=".tree-example .tree-container .core-tree"/>
      </Example>
    );
  }

}

TreeExample.tags = 'infinite scroll';

export default TreeExample;
